module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/brindis-a5371e1fa74953986ea835421c22986c.png";